import { Directive, Input, OnChanges, ElementRef } from '@angular/core';

import { ValidationErrorComponent } from '../components/common/validation-error/validation-error.component';
import { InputValidation } from '../models/inputValidation.model';
import { DynamicComponentsService } from '../services/dynamicComponents.service';

@Directive({
  selector: '[inputValidation]'
})
export class InputValidationDirective implements OnChanges {
  @Input('inputValidation') inputValidation: InputValidation;

  validationErrorElement: HTMLElement;

  constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly dynamicComponentsManager: DynamicComponentsService
  ) { }

  ngOnChanges() {
    const { condition, error } = this.inputValidation;

    this.toggleErrorClass(condition);
    this.toggleError(condition, error);
  }

  private toggleErrorClass(condition: boolean) {
    if (!condition) {
      this.elementRef.nativeElement.classList.remove('invalid');
    } else {
      this.elementRef.nativeElement.classList.add('invalid');
    }
  }

  private toggleError(condition: boolean, error: string) {
    if (!condition) {
      this.destroyValidationError();
    } else {
      this.destroyValidationError();

      this.validationErrorElement = this.dynamicComponentsManager.createComponentElement(ValidationErrorComponent, { error });

      this.elementRef.nativeElement.parentElement.appendChild(this.validationErrorElement);
    }
  }

  private destroyValidationError() {
    if (this.validationErrorElement) {
      this.validationErrorElement.remove();
    }
  }
}